import React, { useState } from "react";
import PlaywrightTemplate from "./PlaywrightTemplate";
import styles from "../../styles/Playwrightpages.module.css";

const PwInput = () => {
  const [email, setEmail] = useState("");
  const [appendText, setAppendText] = useState("APPEND");
  const [clearText, setClearText] = useState("CLEAR ME !!!");

  const sections = [
    {
      heading: "TEXT BOX INTERACTIONS",
      ui: (
        /* use fieldsRow for a single-row layout; other pages still use textGrid */
        <div className={styles.fieldsRow}>
          
          {/* Email */}
          <div className={styles.field}>
            <label>EMAIL</label>
            <input
              type="email"
              placeholder="xxxxx@xxxxx.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {/* Append */}
          <div className={styles.field}>
            <label>APPEND TEXT</label>
            <input
              value={appendText}
              onChange={(e) => setAppendText(e.target.value)}
            />
          </div>

          {/* Get Default Text */}
          <div className={styles.field}>
            <label>GET DEFAULT TEXT</label>
            <input value="BALAMURUGAN" readOnly />
          </div>

          {/* Clear Text */}
          <div className={styles.field}>
            <label>CLEAR TEXT !!!</label>
            <input
              value={clearText}
              onChange={(e) => setClearText(e.target.value)}
            />
          </div>

          {/* Disabled */}
          <div className={`${styles.field} ${styles.fullWidth}`}>
            <label>TEXT FIELD IS DISABLED</label>
            <input value="I am disabled" disabled />
          </div>

        </div>
      ),

      code: `// Fill Email
await page.fill('input[type="email"]', 'test@gmail.com');

// Append Text
await page.fill('input[value="APPEND"]', ' - Playwright');

// Get Default Text
const text = await page.inputValue('input[value="BALAMURUGAN"]');
console.log(text);

// Clear Text
await page.fill('input[value="CLEAR ME !!!"]', '');

// Check Disabled Field
await expect(page.locator('input:disabled')).toBeDisabled();`
    }
  ];

  return <PlaywrightTemplate title="INPUT / TEXT BOX" sections={sections} />;
};

export default PwInput;